export default "__VITE_ASSET__EoLmzdO6__"